import { gql } from '@apollo/client'
import { DISPLAY_WITH_STORE_DATA_FRAGMENT } from '../fragments/DisplayWithStoreDataFragment'

export const GET_STORE_DISPLAY_WITH_STORE_DATA = gql`
  query GetDisplayWithStoreData($displayId: ID!) {
    display(displayId: $displayId) {
      ...DisplayWithStoreData
    }
  }
  ${DISPLAY_WITH_STORE_DATA_FRAGMENT}
`
